import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumberDirective } from './directives/numbers-only.directive';
import { OnlyAlphabetDirective } from './directives/alphabets-only.directive';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { PhoneMask } from './pipes/phone-mask.pipe';
import { AlphabetsWithSymbols} from './directives/alphabetsWithSymbols.directive';
import { AutoCapitalizeDirective } from './directives/auto-capitalize.directive';
import { ModalPopupModule } from './modal-popup/modal-popup.module';

@NgModule({
	declarations: [OnlyNumberDirective, OnlyAlphabetDirective, BlockCopyPasteDirective, PhoneMask, AlphabetsWithSymbols, AutoCapitalizeDirective],
	imports: [
		CommonModule,
		ModalPopupModule
	],
	exports: [OnlyNumberDirective, OnlyAlphabetDirective, BlockCopyPasteDirective, PhoneMask, AlphabetsWithSymbols, AutoCapitalizeDirective, ModalPopupModule]
})
export class SharedModule { }
